// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__O0T7M","wrapperInner":"Home_wrapperInner__BoVcN"};